import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const updateBagParam = createAction(ACTION.UPDATE_BAG_PARAM.REQUEST, (bagId, param, value) => ({bagId, param, value}));
export const resetError = createAction(ACTION.RESET_ERROR, (param) => ({param}));
export const clearState = createAction(ACTION.CLEAR_STATE, (param) => ({param}));
